export default "__VITE_ASSET__BoYKN_Pi__"